import React from 'react';
import {
  arrayOf,
  shape,
  string,
  bool,
  number,
  func
} from 'prop-types';
import {
  RadioGroup,
  Radio,
  SelectionControlLabel
} from '@one-thd/sui-atomic-components';
import { CATEGORY_LABEL_MAPPING } from '../../../constants';

export const ItemPodLower = ({
  hasMultipleProducts,
  products,
  productGroup,
  checked,
  radioValue,
  onRadioChange
}) => {

  const constructLabel = ({ label, defaultQuantity }) => {
    if (defaultQuantity > 1) {
      return `${label}s (Qty ${defaultQuantity})`;
    }
    return label;
  };

  return (
    <>
      {hasMultipleProducts && (
        <RadioGroup
          aria-labelledby="product-radio-buttons"
          name="radio-buttons-group"
          value={radioValue}
          onChange={onRadioChange}
        >
          {products.map(({ product, defaultQuantity, category }, index) => {
            return (
              <SelectionControlLabel
                key={`${productGroup}-${product.info.label}`}
                value={index}
                label={constructLabel({
                  label: CATEGORY_LABEL_MAPPING[category] ?? product.info.label,
                  defaultQuantity
                })}
              >
                <Radio disabled={!checked} />
              </SelectionControlLabel>
            );
          })}
        </RadioGroup>
      )}
    </>
  );
};

ItemPodLower.propTypes = {
  hasMultipleProducts: bool.isRequired,
  products: arrayOf(shape({})).isRequired,
  productGroup: string.isRequired,
  checked: bool.isRequired,
  radioValue: number.isRequired,
  onRadioChange: func.isRequired
};